package stocking;
import pixi.core.renderers.SystemRenderer;
import pixi.core.display.Container;
import pixi.loaders.Loader;
import pixi.loaders.ResourceLoader;
import pixi.loaders.Resource;
import gif.images.GifDecoder;
import pixi.core.textures.Texture;
import pixi.extras.AnimatedSprite;

import stocking.AudioManager;

typedef PreloadImage = {
	var filename : String;
	@:optional var alias : String;
}

class Scene
{

	var renderer:SystemRenderer;
	var stage:Container;
	var container:Container;
	private var loaded(get, null) = false;
	private var exited(get, null) = false;
	private var ready(get, null) = false;

	private var loaderImages : Array<PreloadImage>;
	private var loaderData : Array<PreloadImage>;
	private var loaderSfx : Array<String>;
	private var loaderFonts : Array<String>;
	private var loaderGifs : Array<String>;
	private var loader : Loader;

	private var gifCache = new Map<String,Array<Texture>>();
	private var dataCache = new Map<String,Dynamic>();

	public function get_exited()	return exited;
	public function get_ready()		return ready;

	public var nextScene : Scene;

	public function new( renderer : SystemRenderer, stage : Container )
	{
		this.renderer = renderer;
		this.stage = stage;
		this.container = new Container();
	}

	public function get_loaded()
	{
		return loaderImages == null && loaderData == null && loaderFonts == null ;//&& ( loaderSfx == null || loaderSfx.length == 0);
	}

	/**
	 *  Called before the scene is presented, to allow assets to be loaded before enter()
	 */
	public function preload()
	{
		if( loaderImages != null && loaderImages.length > 0 )
		{
			var loader = new Loader();

			for (url in loaderImages )
			{
				if( url.alias != null )
					loader.add(url.alias, url.filename);
				else
					loader.add(url.filename);
			} 
			
			loader.load(onLoadedImages);
		}

		if( loaderData != null && loaderData.length > 0 )
		{
			var loader = new Loader();

			for (url in loaderData )
			{
				if( url.alias != null )
					loader.add(url.alias, url.filename);
				else
					loader.add(url.filename);
			} 
			
			loader.load(onLoadedData);
		}

		if( loaderGifs != null && loaderGifs.length > 0 )
		{
			
			var options : pixi.loaders.LoaderOptions = { loadType: cast LoadType.XHR, xhrType: "arraybuffer" };

			var loader = new Loader();
			loader.use(gifMiddleware);

			for (url in loaderGifs )
			{
				loader.add(url,options);
			} 
			
			loader.load(onLoadedGifs);
		}

		if( loaderSfx != null && loaderSfx.length > 0 )
		{
			for (url in loaderSfx )
			{
				AudioManager.instance.preloadBuffer(url, onLoadedSfx );
			} 
		}

		if( loaderFonts != null && loaderFonts.length > 0 )
		{
			var loader = new Loader();

			for (url in loaderFonts )
			{
				loader.add(url);
			} 
			
			loader.load(onLoadedFonts);
		}
		
	}

	private function onLoadedImages()
	{
		loaderImages = null;
	}

	private function onLoadedData(cb: ResourceLoader)
	{
		for( key in cb.resources.keys() )
		{
			var resource = cb.resources[key];
			dataCache.set(resource.name, resource.data);
		}
		loaderData = null;
	}


	private function gifMiddleware( resource: Resource, next : Void -> Void )
	{
		var startTime = Date.now().getTime();
		var bytes : haxe.io.Bytes;

		bytes = haxe.io.Bytes.ofData( resource.xhr.response );

		var bmaps = new Array<pixi.core.textures.Texture>();
		var frames = GifDecoder.decode( bytes ).frameList;

		trace("Decoded gif in " + ( Date.now().getTime() - startTime ) + "ms" );
		startTime = Date.now().getTime();

		var combinedCanvas = js.Browser.document.createCanvasElement();
		combinedCanvas.width = frames[0].imageWidth;
		combinedCanvas.height = frames[0].imageHeight;
		var combinedCtx = combinedCanvas.getContext2d();
		var combinedImageData = combinedCtx.createImageData(frames[0].imageWidth,frames[0].imageHeight);

		var pixel = combinedCtx.getImageData(0, 0, 1, 1);

		for(gifFrameInfo in frames)
		{
			var canvas = js.Browser.document.createCanvasElement();
			var ctx = canvas.getContext2d();
			var imageData = ctx.createImageData(gifFrameInfo.imageWidth,gifFrameInfo.imageHeight);

			var textureCanvas = js.Browser.document.createCanvasElement();
			canvas.width = textureCanvas.width = combinedCanvas.width;
			canvas.height = textureCanvas.height = combinedCanvas.height;
			var textureCtx = textureCanvas.getContext2d();

			
			//var bitmapData= pixi.core.textures.Texture.from ( gifFrameInfo.imageWidth,gifFrameInfo.imageHeight);
			var rgbaImageData = gifFrameInfo.getRgbaImageData();
			var index = 0;
			// @todo
			if (gifFrameInfo.interlaceFlag)
			{
				throw "Needs fixed/tested.";
				var startingLine = 0;
				var lineIncrement = 8;
				var line = 0;
				for (pass in 0...4)
				{
					switch (pass)
					{
						case 0: { startingLine = 0; lineIncrement = 8; }
						case 1: { startingLine = 4; lineIncrement = 8; }
						case 2: { startingLine = 2; lineIncrement = 4; }
						case 3: { startingLine = 1; lineIncrement = 2; }
					}
					line = startingLine;
					while (line < gifFrameInfo.imageHeight)
					{
						for (xIndex in 0...gifFrameInfo.imageWidth)
						{
							var rgba = rgbaImageData[index];
							combinedCtx.putImageData(pixel,xIndex, line);
							index++;
						}
						line += lineIncrement;
					}
				}
			}
			else
			{
				trace("Lib time: " + ( Date.now().getTime() - startTime ) + "ms" );
				startTime = Date.now().getTime();
				//var data = new js.html.Uint8Array(rgbaImageData.length*4);
				for (i in 0...rgbaImageData.length)
				{
					var rgba = rgbaImageData[i];
					
					imageData.data.set([rgba.red, rgba.green, rgba.blue, rgba.alpha], i*4);
				}
			}
			
			trace("Converted single frame in " + ( Date.now().getTime() - startTime ) + "ms" );
			startTime = Date.now().getTime();
			
			combinedCtx.drawImage(canvas,gifFrameInfo.imageLeftPosition, gifFrameInfo.imageTopPosition);
			textureCtx.drawImage( combinedCanvas, 0, 0 );

			var texture = Texture.fromCanvas(textureCanvas);
			
			bmaps.push(texture);
			gifFrameInfo.clearBinaryData();

			
			trace("Canvas ops took " + ( Date.now().getTime() - startTime ) + "ms" );
			startTime = Date.now().getTime();

		}

		gifCache.set( resource.name, bmaps );

		trace("Converted to textures in " + ( Date.now().getTime() - startTime ) + "ms" );

		next();
	}

	private function onLoadedGifs(cb: ResourceLoader)
	{
		loaderGifs = null;
	}

	private function onLoadedFonts()
	{
		loaderFonts = null;
	}

	private function onLoadedSfx()
	{
		loaderSfx.pop();
		trace("Audio loaded callback");
	}

	/**
	 *  Called when rendering is handed off to this scene
	 */
	public function enter()
	{
		this.stage.addChild( this.container );
		this.ready = true;
	}

	/**
	 *  Logic update loop. 
	 *  @param delta - Delta time since last call.
	 */
	public function tick( delta:Float )
	{

	}


	/**
	 *  Begin our exit animation if any. set exited=true when done
	 */
	public function exit()
	{
		this.stage.removeChild( this.container );
		exited = true;
	}

	/**
	 *  Called after the scene is about to be dereferenced.  
	 */
	public function unload()
	{
		
		this.container = new Container();
	}


}